import axios from "axios";


export const patchUserSettings = async (userId, data) => {
    const url = `/api/v1/users/${userId}/settings`;
    const res = await axios.patch(url, data);
    return res.data;
}